import React from 'react'
import { useNavigation } from '../../contexts/NavigationContext'

interface PageLayoutProps {
  children: React.ReactNode
  title?: string
  subtitle?: string
  showNav?: boolean
}

export function PageLayout({ children, title, subtitle, showNav = true }: PageLayoutProps): React.ReactElement {
  const { setCurrentPage, openModal } = useNavigation()

  const handleFooterLink = (target: string) => {
    if (target === 'about' || target === 'contact' || target === 'parentsGuide' || target === 'security' || target === 'cookies') {
      openModal(target as any)
    } else if (target === 'features' || target === 'pricing' || target === 'blog' || target === 'help' || target === 'careers' || target === 'privacy' || target === 'terms') {
      setCurrentPage(target as any)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 via-pink-50 to-blue-50">
      {/* Sticky Navigation */}
      {showNav && (
        <nav className="sticky top-0 z-50 bg-white border-b-4 border-purple-200 shadow-lg">
          <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-400 to-pink-400 rounded-2xl flex items-center justify-center text-white font-bold text-2xl shadow-lg">
                👶
              </div>
              <div>
                <h1 className="text-2xl font-black text-purple-700">BabyKingdom</h1>
                <p className="text-xs text-pink-600 font-bold">Magic & Fun for Kids</p>
              </div>
            </div>
            <button 
              onClick={() => setCurrentPage('game' as any)}
              className="px-6 py-2 bg-gradient-to-r from-pink-400 to-purple-400 text-white font-bold rounded-full shadow-lg hover:shadow-xl transition hover:scale-105"
            >
              Account 👤
            </button>
          </div>
        </nav>
      )}

      {/* Page Content */}
      <div className="px-8 py-12">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          {title && (
            <div className="mb-12 text-center">
              <h1 className="text-6xl font-black text-purple-700 mb-3">
                {title}
              </h1>
              {subtitle && (
                <p className="text-2xl text-gray-700 font-bold">
                  {subtitle}
                </p>
              )}
            </div>
          )}

          {/* Children Content */}
          {children}
        </div>
      </div>

      {/* Footer */}
      <footer className="px-8 py-12 bg-white border-t-4 border-purple-200 mt-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h4 className="text-lg font-black text-purple-700 mb-3">Product</h4>
              <ul className="space-y-1">
                <li><button onClick={() => handleFooterLink('features')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Features</button></li>
                <li><button onClick={() => handleFooterLink('pricing')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Pricing</button></li>
                <li><button onClick={() => handleFooterLink('security')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Security</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-black text-purple-700 mb-3">Company</h4>
              <ul className="space-y-1">
                <li><button onClick={() => handleFooterLink('about')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">About</button></li>
                <li><button onClick={() => handleFooterLink('blog')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Blog</button></li>
                <li><button onClick={() => handleFooterLink('careers')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Careers</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-black text-purple-700 mb-3">Support</h4>
              <ul className="space-y-1">
                <li><button onClick={() => handleFooterLink('help')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Help</button></li>
                <li><button onClick={() => handleFooterLink('contact')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Contact</button></li>
                <li><button onClick={() => handleFooterLink('parentsGuide')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Parents Guide</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-black text-purple-700 mb-3">Legal</h4>
              <ul className="space-y-1">
                <li><button onClick={() => handleFooterLink('privacy')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Privacy</button></li>
                <li><button onClick={() => handleFooterLink('terms')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Terms</button></li>
                <li><button onClick={() => handleFooterLink('cookies')} className="text-gray-700 hover:text-pink-600 font-bold cursor-pointer">Cookies</button></li>
              </ul>
            </div>
          </div>
          <div className="border-t-2 border-purple-200 pt-6 text-center">
            <p className="text-purple-700 font-black">
              © 2026 BabyKingdom ✨ | Where every baby becomes a hero!
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}
